import { createFileRoute } from '@tanstack/react-router'

import { CaseStudyLayout } from '../components/CaseStudyLayout'
import { peaque } from '../caseStudies/peaque'
import { caseStudyHead } from '../caseStudySeo'

export const Route = createFileRoute('/Peaque')({
  head: () => caseStudyHead(peaque.content),
  component: PeaquePage,
})

function PeaquePage() {
  return <CaseStudyLayout content={peaque.content} />
}
